import { render, staticRenderFns } from "./TableAssignmentsPage.vue?vue&type=template&id=98676754&scoped=true&lang=pug"
import script from "./TableAssignmentsPage.vue?vue&type=script&lang=js"
export * from "./TableAssignmentsPage.vue?vue&type=script&lang=js"
import style0 from "./TableAssignmentsPage.vue?vue&type=style&index=0&id=98676754&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98676754",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98676754')) {
      api.createRecord('98676754', component.options)
    } else {
      api.reload('98676754', component.options)
    }
    module.hot.accept("./TableAssignmentsPage.vue?vue&type=template&id=98676754&scoped=true&lang=pug", function () {
      api.rerender('98676754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/my_tasks/TableAssignmentsPage.vue"
export default component.exports